/*
 * @Author: zhenhui.duan
 * @Date: 2024-05-15 11:33:41
 * @Description:
 */
// 符合条件时才创建子元素
export function Create({ when, children }) {
  if (when) {
    return children;
  }
  return null;
}
